export default "__VITE_ASSET__99cfb04b__"